module.exports = __webpack_public_path__ + "img/190220_Raumflug_Webseite2.6d163e07.jpg";